import { render } from "./ProviderTrainingCertificatePrint.vue?vue&type=template&id=5e8b8739&scoped=true"
import script from "./ProviderTrainingCertificatePrint.vue?vue&type=script&lang=js"
export * from "./ProviderTrainingCertificatePrint.vue?vue&type=script&lang=js"

import "./ProviderTrainingCertificatePrint.vue?vue&type=style&index=0&id=5e8b8739&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8b8739"]])

export default __exports__